var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearHalfMaskRespirator50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.849,18.038C35.07,12.711,31.078,8,23.5,8C15,8,11,13.925,11,20v1h30v-1L35.849,18.038z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29,39h-2v-4h6v-7.072l0.615-0.256c0,0,1.331-0.555,1.414-0.59l-0.093-0.1L33,23.376V22 c0-5.514-4.262-10-9.5-10S14,16.486,14,22c0,4.516,1.301,6.931,2.449,9.061C17.247,32.541,18,33.938,18,35.676V39h-2v-3.324 c0-1.232-0.579-2.307-1.312-3.666C13.491,29.787,12,27.021,12,22c0-6.617,5.159-12,11.5-12S35,15.383,35,22v0.874l1.675,3.12 c0.347,0.534,0.42,1.202,0.195,1.801c-0.185,0.493-0.547,0.887-1.018,1.109c-0.01,0.005-0.455,0.19-0.852,0.356v3.048 C35,34.896,32.875,37,30.262,37H29V39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26,29H14v-2h12c6.27,0,8.159-2.542,8.177-2.567l1.655,1.122C35.738,25.695,33.45,29,26,29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.8,25.4L35,22.874v2.55C33.789,26.447,31.108,28,26,28h-5v1l6,8h1h2c4.418,0,8-3.582,8-8 C38,27.702,37.579,26.439,36.8,25.4z M31,35c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2S32.105,35,31,35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearHalfMaskRespirator50);
export default __webpack_public_path__ + "static/media/icons8-wear-half-mask-respirator-50.7601ec0e3f0a1754d3131a44d4d3abcc.svg";
export { ForwardRef as ReactComponent };